/* eslint-disable max-lines */
import React from 'react';

type Option<A> = {
  id: A;
  label: string;
};

type ComponentProps<A> = {
  options: Option<A>[];
  onOptionClicked: (id: A) => void;
  selectedOption: string;
};

const SegmentedButton = <A extends string>(props: ComponentProps<A>): ReturnType<React.FC> => {
  const { options, onOptionClicked, selectedOption } = props;

  const handleOptionClick = (
    e: React.MouseEvent<HTMLButtonElement, MouseEvent>,
    option: Option<A>
  ): void => {
    e.stopPropagation();
    onOptionClicked(option.id);
  };

  const renderOption = (option: Option<A>, idx: number): JSX.Element => {
    let styles = 'button button--secondary';
    if (option.id === selectedOption) {
      styles = `button button--primary`;
    }

    if (idx === 0) {
      styles = `${styles} border-r-0 rounded-r-none`;
    } else if (idx === options.length - 1) {
      styles = `${styles} rounded-l-none`;
    } else {
      styles = `${styles} border-r-0 rounded-none`;
    }

    return (
      <button
        key={option.id}
        type="button"
        onClick={(e): void => handleOptionClick(e, option)}
        className={`h-8 py-1.5 px-2 border border-litlingo-gray-3 focus:outline-none ${styles}`}
      >
        <span className={`font-bold ${option.id === selectedOption ? 'text-white' : ''}`}>
          {option.label}
        </span>
      </button>
    );
  };

  return (
    <div className="w-full flex flex-row bg-white">
      {options.map((option, idx) => renderOption(option, idx))}
    </div>
  );
};

export default SegmentedButton;
